import type { TFunction } from "i18next";

import type { OrgView } from "@/api/hooks";

/** An organisation's name as the admin area shows it: the root
 *  organisation says so, in words a translator can place. */
export function orgDisplayName(t: TFunction, org: Pick<OrgView, "name" | "is_root">): string {
  return org.is_root ? t("admin.org_switcher.root_option", { name: org.name }) : org.name;
}
